// extracted by mini-css-extract-plugin
export default {"card":"Card_card__uFbbj","card_title":"Card_card_title__pIOJG","pass":"Card_pass__0+Ot+","fail":"Card_fail__URc5i"};